import { type RouteRecordRaw } from 'vue-router';

const SearchView = () =>
  import(/* webpackChunkName: "Search" */ 'PortalDir/modules/Search/pages/SearchView.vue');

const routes: Array<RouteRecordRaw> = [
  {
    path: '/search',
    name: 'search-view',
    component: SearchView,
    props: (route) => ({
      ...route.query
    }),
    meta: {
      hideFooter: true,
    },
  },
];

export default routes;
